module.exports = __webpack_public_path__ + "r-v3/img/rectangle.c0d21621.svg";